module.exports = __webpack_public_path__ + "assets/img/Kaplan-Professional-Pillar-Page-Resource.bc139948.jpg";